export const SET_USER_CONFIG = 'SET_USER_CONFIG';
export const SET_USER_PREF = 'SET_USER_PREF';
export const SET_MASTER_APP_LOADING = 'SET_MASTER_APP_LOADING';
